import React from "react";

function NotFound() {
  return (
    <div>
      <h1>I can't find the page you're looking for :( </h1>
    </div>
  );
}

export default NotFound;
